





import Vue from 'vue';

export default Vue.extend({
    props: {
        size: String,
        display: Boolean,
    },
    computed: {
        sizeStyle() {
            let w: number;
            let h: number;
            [w, h] = this.size.split('x').map((n: string) => parseInt(n.trim(), 10));
            return {
                '--width': `${w}px`,
                '--height': `${h}px`,
            };
        },
    },
});
